import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import d365Auth from '../services/d365Auth';

function D365Callback({ onConnected }) {
  const [status, setStatus] = useState('Processing...');
  const [error, setError] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (!currentUser) {
        setStatus('Please log in first');
        setError('You must be logged in to connect Dynamics 365.');
        setTimeout(() => { window.location.href = '/'; }, 3000);
        return;
      }

      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      const errorParam = urlParams.get('error');

      const savedState = sessionStorage.getItem('d365_oauth_state');
      if (!state || state !== savedState) {
        setStatus('Security Error');
        setError('Sign-in could not be completed. Close this window and try connecting again from Integrations.');
        sessionStorage.removeItem('d365_oauth_state');
        sessionStorage.removeItem('d365_oauth_environment');
        setTimeout(() => { window.location.href = '/'; }, 5000);
        return;
      }

      sessionStorage.removeItem('d365_oauth_state');
      const environment = sessionStorage.getItem('d365_oauth_environment');
      sessionStorage.removeItem('d365_oauth_environment');

      if (errorParam) {
        const errorDesc = urlParams.get('error_description') || errorParam;
        setStatus(`Error: ${errorParam}`);
        setError(errorDesc);
        setTimeout(() => { window.location.href = '/integrations'; }, 5000);
        return;
      }

      if (code) {
        d365Auth.exchangeCodeForToken(code, state)
          .then(async (tokens) => {
            await d365Auth.saveTokens(tokens, environment);
            setStatus('Success! Dynamics 365 connected. Redirecting...');
            if (onConnected) onConnected();
            setTimeout(() => { window.location.href = '/integrations'; }, 2000);
          })
          .catch((err) => {
            setStatus(`Error: ${err.message}`);
            setError(err.message);
            setTimeout(() => { window.location.href = '/integrations'; }, 5000);
          });
      } else {
        setStatus('No authorization code received');
        setError('The authorization code is missing from the URL.');
        setTimeout(() => { window.location.href = '/integrations'; }, 3000);
      }
    });

    return () => unsubscribe();
  }, [onConnected]);

  return (
    <div style={{ padding: '40px', textAlign: 'center', maxWidth: '600px', margin: '0 auto' }}>
      <h2>Dynamics 365 Finance & Supply Chain Authorization</h2>
      <p style={{ fontSize: '18px', marginTop: '20px' }}>{status}</p>
      {error && (
        <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#fee', border: '1px solid #fcc', borderRadius: '5px' }}>
          <strong>Details:</strong> {error}
        </div>
      )}
      <p style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
        You will be redirected automatically...
      </p>
    </div>
  );
}

export default D365Callback;
